import * as actions from './actions';

const initialState = {
    data: null,
    error: null,
    initial: false,
    loading: false,
};

const trendingDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.FETCH_TRENDING_DATA.REQUEST:
            return { ...state, loading: true, error: null };

        case actions.FETCH_TRENDING_DATA.SUCCESS: {
            const { data } = action.payload;
            return { ...state, loading: false, initial: true, data };
        }

        case actions.FETCH_TRENDING_DATA.FAILURE:
            return { ...state, loading: false, initial: false, error: action.payload.error };

        default:
            return state;
    }
};

export default trendingDataReducer;
